import React, {useState} from "react";


function DocumentStatus({localPagesDocument, locationPatch, setFormIsDirty}) {
    const [publish, setPublish] = useState(localPagesDocument.publishedStatus)
    const [publishedUrl, setPublishedUrl] = useState(localPagesDocument.publishedUrl)


    const publishCheckBoxSelected = () => {
        setPublish(!publish)
        locationPatch.localPages.localPagesLocationDocument.publishedStatus = !publish;
        setFormIsDirty(true)
    }

    const publishedUrlChanged = (event) => {
        setPublishedUrl(event.target.value)
        locationPatch.localPages.localPagesLocationDocument.publishedUrl = event.target.value
        setFormIsDirty(true)
    }


    return <div className="form-group mt-2 border-top">
        <h5 className="mt-3">Status</h5>
        <div className="form-check">
            <div className="row">
                <div className="col-md-11">
                    <input type="checkbox" className="form-check-input" id="publishCheck" checked={publish}
                           onChange={publishCheckBoxSelected}/>
                    <label className="form-check-label" htmlFor="publishCheck">
                        Live &nbsp; (This will push all data live to all locations selected)
                    </label>
                </div>
            </div>
        </div>
        <div className={"row mt-2 mb-2"}>
            <div className="col-sm-2"> Preview Site: </div>
            <div className="col-sm-10">
                <a href={localPagesDocument.previewUrl}target = "_blank"
                   rel = "noopener noreferrer">{localPagesDocument.previewUrl}</a>
            </div>
        </div>
        <div className={"row"}>
            <div className="col-sm-2">
                Live URL:
            </div>
            <div className="col-sm-10">
                <input className="form-control text-input" value={publishedUrl} onChange={publishedUrlChanged} />
            </div>
        </div>
    </div>

}

export default DocumentStatus;